module.exports = __webpack_public_path__ + "img/top.d88a2962.png";